/**
 * Web mirror of the backend-owned scoring-source tokens.
 *
 * The `top-tldr-<N>` size set is owned by
 * backend/app/services/top_tldr_source.py (TOP_TLDR_SIZES); the
 * quality-scoring endpoint's unparsed default token by
 * backend/app/services/scoring_source.py (RECENT_SCORED_TOKEN). The admin
 * pages cannot import the owner, so this module carries the only web copy —
 * every page builds its dropdown entries and request defaults from here.
 * backend/tests/test_scoring_source_client_parity.py pins this mirror to the
 * owner and rejects raw token literals reintroduced elsewhere in the web
 * client, so a size added or removed on one side fails CI instead of a
 * dropdown silently offering a token the backend refuses.
 */

export const TOP_TLDR_SIZES = [25, 100, 250, 500, 1000, 2500] as const;

export type TopTldrSize = (typeof TOP_TLDR_SIZES)[number];

/** Spell the `top-tldr-<N>` source token for an accepted size. */
export function topTldrToken(n: TopTldrSize): string {
  return `top-tldr-${n}`;
}

/** Dropdown entry for a `top-tldr-<N>` source, shared by the admin pages. */
export function topTldrOption(
  n: TopTldrSize,
  description?: string,
): { id: string; label: string; description?: string } {
  return { id: topTldrToken(n), label: `Top ${n} by score`, description };
}

/** The quality-scoring endpoint's default source token (unparsed fallback). */
export const RECENT_SCORED_TOKEN = 'recent-scored';
